// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2f-1";
export var movingGradient = "_2f-4";
export var movingGradientBlock = "_2f-2";
export var skeleton = "_2f-0";
export var skeletonText = "_2f-3";